<template>
  <IQOS :title="'Нагадування про статус балансу'" class="reminder-container">
    <p
      class="c-grey comment"
    >Налаштуйте нагадування, яке буде Вам відправлятись якщо баланс досягне певної суми.</p>

    <h5 class="reminder-control c-white">
      Нагадати про поповнення балансу, якщо він буде менший:
      <BaseInput
        class="reminder-input"
        :value="`${reminder_threshold || 0} грн.`"
        placeholder="100 грн"
        :readonly="true"
        v-if="!editing"
      />
      <BaseInput
        class="reminder-input"
        v-model.number="reminder_threshold"
        type="number"
        placeholder="100 грн"
        :readonly="false"
        v-if="editing"
      />
    </h5>

    <IQOSActions :editing="editing" @edit="showEditUI" @cancel="hideEditUI" @accept="onEditFinish" />
  </IQOS>
</template>

<script>
import IQOS from "@/components/IQOS.vue";
import IQOSActions from "@/components/IQOSActions.vue";

import BlackInput from "@/components/BlackInput.vue";

import BillingAPI from "@/api/billing";

export default {
  data() {
    return {
      editing: false,

      reminder_threshold: null
    };
  },
  methods: {
    showEditUI() {
      this.editing = true;
    },
    hideEditUI() {
      this.editing = false;
      this.resetValue();
    },
    onEditFinish() {
      if (!this.reminder_threshold) {
        return;
      }

      this.editing = false;

      BillingAPI.updateReminderSettings(Math.round(this.reminder_threshold))
        .then(data => {
          this.$store.commit("setBillingAccount", data.account);
        })
        .catch(error => {
          this.$store.dispatch("showError", "billing_fetch");
        });
    },
    resetValue() {
      if (this.billing_account.reminder_threshold) {
        this.reminder_threshold = this.billing_account.reminder_threshold;
      } else {
        this.reminder_threshold = null;
      }
    }
  },
  computed: {
    billing_account() {
      return this.$store.state.billing_account;
    }
  },
  mounted() {
    this.resetValue();
  },
  components: {
    IQOS,
    IQOSActions,
    BlackInput
  }
};
</script>

<style scoped>
p {
  margin: 0;
}

.reminder-container {
  width: 66vh !important;
}

.reminder-control {
  display: flex;
  font-size: 2vh;

  margin-top: 2vh;
}

.reminder-input {

  width: 27vh;
}
</style>